// src/components/common/SectionHeader.js
import React from 'react';

function SectionHeader({ title, optional = false }) {
  // Section is always expanded, so no toggle or minus/plus button
  return (
    <div className="section-header">
      <h2>
        {title}
        {optional && (
          <span className="optional-badge">Optional</span>
        )}
      </h2>
    </div>
  );
}

export default SectionHeader;